export default __webpack_public_path__ + "topBar.c8440d9.png";